import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaFacebookF, FaInstagram, FaGoogle, FaChevronDown } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import defaultLogo from '../assets/logo.png';
import { API_BASE, BACKEND_URL } from '../config';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [kvkkOpen, setKvkkOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);
  const [kvkkPages, setKvkkPages] = useState([]);
  const [social, setSocial] = useState({ facebook: '', twitter: '', instagram: '', google: '' });
  const [logoSrc, setLogoSrc] = useState(defaultLogo);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    fetch(`${API_BASE}/pages?category=kvkk`)
      .then(res => res.json())
      .then(data => setKvkkPages(data))
      .catch(() => {});

    fetch(`${API_BASE}/contact`)
      .then(r => r.json())
      .then(data => { if (data && data.socialLinks) setSocial(data.socialLinks); })
      .catch(() => {});

    fetch(`${API_BASE}/settings`)
      .then(r => r.json())
      .then(data => {
        if (data && data.headerLogo) setLogoSrc(`${BACKEND_URL}${data.headerLogo}`);
      })
      .catch(() => {});
  }, []);

  const menuItems = [
    { label: 'Ana Sayfa', href: '/' },
    { label: 'Hakkımızda', href: '/hakkimizda' },
    { label: 'Duyurular', href: '/duyurular' },
    { label: 'Etkinlikler', href: '/etkinlikler' },
  ];

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="header-container">
        <nav className="header-nav-left">
          <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
          <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            {menuItems.map((item, index) => (
              <li key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                <Link to={item.href} onClick={() => setMenuOpen(false)}>
                  <span className="nav-dot">•</span>
                  {item.label}
                </Link>
              </li>
            ))}
            {/* KVKK Dropdown */}
            {kvkkPages.length > 0 && (
              <li className={`nav-dropdown ${kvkkOpen ? 'nav-dropdown--open' : ''}`} style={{ animationDelay: `${menuItems.length * 0.1}s` }}>
                <span className="nav-dropdown-toggle" onClick={() => setKvkkOpen(!kvkkOpen)}>
                  <span className="nav-dot">•</span>
                  KVKK <FaChevronDown className="nav-dropdown-arrow" />
                </span>
                <ul className="nav-dropdown-menu">
                  {kvkkPages.map(page => (
                    <li key={page._id}>
                      <Link to={`/${page.slug}`} onClick={() => { setMenuOpen(false); setKvkkOpen(false); }}>
                        {page.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            )}
            {/* Mobile: İletişim link */}
            <li className="mobile-contact-item" style={{ animation: 'none', opacity: 1 }}>
              <Link to="/iletisim" onClick={() => setMenuOpen(false)}>
                <span className="nav-dot">•</span>
                İletişim
              </Link>
            </li>
            {/* Mobile Social Links */}
            <li className="mobile-social-wrapper" style={{ animation: 'none', opacity: 1, listStyle: 'none' }}>
              <div className="mobile-social">
                {social.facebook && <a href={social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>}
                {social.twitter && <a href={social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaXTwitter /></a>}
                {social.instagram && <a href={social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>}
                {social.google && <a href={social.google} target="_blank" rel="noopener noreferrer" aria-label="Google"><FaGoogle /></a>}
              </div>
            </li>
          </ul>
        </nav>

        <div className="header-logo">
          <Link to="/">
            <img src={logoSrc} alt="Dihiz" />
          </Link>
        </div>

        <div className="header-right">
          <div className="header-social">
            {social.facebook && <a href={social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>}
            {social.twitter && <a href={social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaXTwitter /></a>}
            {social.instagram && <a href={social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>}
            {social.google && <a href={social.google} target="_blank" rel="noopener noreferrer" aria-label="Google"><FaGoogle /></a>}
          </div>
          <Link to="/iletisim" className="header-contact-btn">Bize Ulaşın</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
